import { FC } from 'react';
// Assets
import NotFoundImg from 'assets/images/not-found.png';

const NotFoundPage:FC = () => {
  return (
    <div className="h-full p-4 flex flex-col justify-center items-center gap-3">
      <img src={NotFoundImg} alt="Page Not Found" className="w-3/4" />
      <h3 className="text-3xl font-semibold">Page Not Found</h3>
      <p className="text-xs text-center">We're sorry, the page you requested could not be found</p>
    </div>
  );
}

export default NotFoundPage;
